var removeHtmlTags = require('../../utils/html').removeHtmlTags;

angular.module('account.main-page', [
  'security.authorization',
  'services.adminResource',
  'resources.Article',
  'angular-growl',
  'resources.Category',
])
  .config(["$stateProvider", function ($stateProvider) {
    $stateProvider
      .state('account.main-page', {
        url: '/main-page',
        title: 'Manage Articles',
        views: {
          'main@': {
            template: require('../../common/templates/main-page.tpl.html'),
            controller: 'MainPageController'
          }
        },
        resolve: {
          user: ["User", "$state", function(User, $state) {
            return User.current(function (user) {
              if (user && user.is_active && user.permissions.is_admin || user.permissions.is_editor) {
                return user;
              }

              return $state.go('unauthorized');
            }).$promise;
          }],
        }
      });
  }])

  .controller('MainPageController',
    ["$scope", "$route", "$location", "$log", "utility", "growl", "STATUSES", "ARTICLE_STYLES", "DEFAULT_EDITION", "APP_IMG_URLS", "Category", "Article", "socket", "localizedMessages", function ($scope, $route, $location, $log, utility, growl, STATUSES, ARTICLE_STYLES, DEFAULT_EDITION, APP_IMG_URLS, Category, Article, socket, localizedMessages) {
      $scope.localizedMessages = localizedMessages;
      STATUSES = STATUSES.map( (status) => Object.assign(status, { value: localizedMessages.get(status.value) }) );
      $scope.imgUrl200 = APP_IMG_URLS['200'];
      $scope.imgUrlNoPhoto = APP_IMG_URLS['NO_PHOTO_200'];

      var maxKey = 0;
      $scope.dataLoaded = false;
      $scope.getOption = function (category) {
        $scope.query.cat_sefriendly = category.sefriendly ? category.sefriendly : undefined;
        $scope.chosenLocale = category.sefriendly ? category.sefriendly : '';
        fetchData();
      };

      $scope.getArticlesByStatus = function (statusCode, edition) {
        $scope.dropStatus = statusCode;
				$scope.query.cat_sefriendly = undefined;
				$scope.query.edition = edition;
        $scope.query.status = $scope.dropStatus;
        fetchData();
      };

      $scope.getLimit = function () {
        $scope.query.limit = $scope.query.limit;
        fetchData();
      };

      // local var
      var deserializeData = function (data) {
        if (!data) return;
        $scope.page = data.meta.page;
        $scope.query = data.meta.query;
        $scope.mainArticles = data.data.map( function(a) {
          a.title = removeHtmlTags(a.title);
          return a;
			  });
      };

      var fetchData = function () {
        $scope.dataLoaded = true;
        $scope.query.sort = "-orderNumber";
        // console.log( '>>>', $scope.query );
        Article.query($scope.query).$promise.then(function (data) {
          $scope.locale = _.find($scope.editions, { sefriendly : $scope.chosenLocale})
          // console.log(data)
          deserializeData(data);
          //update url in browser addr bar
          //$scope.query.sort = "orderNumber";
          if (data.data[0]) {
            maxKey = data.data[0].orderNumber;
          }
          // console.log(maxKey)
          $location.search($scope.query);
        }, function (e) {
          $log.error(e);
        });
      };

      $scope.fetchArticles = function (offset) {
        $scope.query.skip = offset;
        fetchData();
      };

      $scope.dropToMainCallback = function (event, index, item, external, type) {
        return item;
      }
      $scope.dropToMyCallback = function (event, index, item, external, type) {
        item.status = 1;
        Article.update(item, function (result) {
        }).$promise.then(function () {
        });
        return item;
      }

      $scope.$watchCollection('query', function (newState, oldState) {
        if (angular.equals(newState, oldState)) {
          return;
        }
        //fetchData();
      });

      $scope.getLabel = function (status) {
				var status = _.find(STATUSES, {id: status + ''});
        return status ? status.value.split("?").join('') : '';
      };

      $scope.getStyle = function (status) {
        var status = _.find(STATUSES, {id: status + ''});
        return {
          color: status ? status.color : '',
          background: status ? status.background : ''
        }
      };

      $scope.saveOrder = function () {
        $scope.dataLoaded = false;

        var newOrders = $scope.mainArticles.map(function (value, index) {
          return {index: index, value: value};
        });

        async.mapSeries(newOrders, function (item, cbMap) {
          item.value.orderNumber = maxKey - item.index;
          Article.update(item.value, function () {
            cbMap(null)
          });
        },function () {
          $scope.dataLoaded = true;
          growl.info('Order saved!');
        })
      }

      $scope.limits = [
        {label: "1 Materiałów", value: 1},
        {label: "5 Materiałów", value: 5},
        {label: "10 Materiałów", value: 10},
        {label: "20 Materiałów", value: 20},
        {label: "50 Materiałów", value: 50}
      ];
      $scope.query = $location.search();
      $scope.dropStatus = 17;
      $scope.query.limit = $scope.query.limit || 50;
      $scope.query.status = $scope.dropStatus;
      //get categories list
      async.parallel({
        categories: function (cb) {
          var options = [];
          var generateCategoryOptions = function (items, container) {
            items.forEach(function (item) {
              if (!item.path) {
                return;
              }
              var depth = item.path.split('/').filter(Boolean).length;
              var indent = (new Array(5)).join(String.fromCharCode(160));
              container.push({
                _id: item.id,
                path: item.path,
                sefriendly: item.sefriendly,
                parent: item.parent,
                name: item.name,
                _name: (new Array(depth)).join(indent) + item.name
              });
              if (item.children) {
                generateCategoryOptions(item.children, container);
              }
            });
            return container;
          };
          Category.getPermittedTree().$promise.then(function (data) {
            generateCategoryOptions(data, options);
            cb(null, options);
          });
        }
      }, function (err, results) {
        if (err) return console.log(err);
        $scope.viewEditions = {
          es : false,
          ar : false,
          br : false,
          it : false,
          en : false,
          mx : false,
          "en-us" : false,
          lat : false,
          pt: false,
          fr :false,
          ru :false,
          arb : false
        }
        $scope.editions = [];
				results.categories.forEach(function (category) {
						$scope.editions.push(category);
						$scope.viewEditions[category.path] = true
				})
        fetchData();
        $scope.categories = results.categories;
      });
    }]);



// WEBPACK FOOTER //
// ./client/src/app/account/main-page/main-page.js